import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../shared/store';
import { useHttpClient } from '../../../shared/http-client';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { CheckIcon, ExclamationCircleIcon, XIcon } from '@heroicons/react/outline';
import { Exclamacion } from '../../../../assets/icons/Exclamacion';
import { ExclamacionYellow } from '../../../../assets/icons/ExclamacionYellow';
import { VehiculosForm } from './vehiculos-form';
import { AsignacionesTab } from './tabs/asignaciones-tab';
import { MantenimientoTab } from './tabs/mantenimiento-tab';
import { ItvTab } from './tabs/itv-tab';
import { SegurosTab } from './tabs/seguros-tab';
import { AccidentesTab } from './tabs/accidentes-tab';
import { MultasTab } from './tabs/multas-tab';
import { ControlKmTab } from './tabs/control-km-tab';
import { ControlGasolinaTab } from './tabs/control-gasolina-tab';
import { CompraTab } from './tabs/compra-tab';
import { UltimaPosicionTab } from './tabs/ultima-posicion-tab';



export const VehiculosEdit = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { get, set } = useStore();
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const [data, setData] = useState<any | null>(null);
    const [tabIndexMaster, setTabIndexMaster] = useState(+get('vehicles-tab-index') || 0);
    const [isTab, setIsTab] = useState(false);

    useEffect(() => {
        if (id) {
            api(`/fleet/vehicles/${id}/`, 'GET');
        }
    }, [id]);

    const handleChangeValues = () => {
        setIsTab(true);
    };

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('vehicles')) {
                setData(state.data);
                /*  if (!isTab) {
                     setTabIndexMaster(0);
                 } */

            }
        }

        if (state.error) {
            //toast.error('Server Error');
        }
    }, [state]);

    return (
        <div className='py-4 px-8'>
            <div
                className="pb-4 cursor-pointer"
                onClick={() => {
                    navigate(-1);
                    setTabIndexMaster(0);
                    set('vehicles-tab-index', 0);
                }}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <div className='flex'>
                <div className="text-2xl  text-gray-900 pb-4 pr-2">
                    {t('common.label.vehiculo')}
                </div>
                <span className='pl-[2px] mt-[6px]'>{data?.status === "OK" ? (
                    <CheckIcon
                        className={
                            'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                        }
                    />
                ) : data?.status === "WARNING" ? (
                    <ExclamacionYellow />
                ) : (
                    <Exclamacion />
                )}</span>
            </div>

            <Tabs
                selectedIndex={tabIndexMaster}
                onSelect={(index) => {
                    setTabIndexMaster(index);
                    set('vehicles-tab-index', index);
                }}>
                <TabList>
                    <Tab style={{ fontWeight: tabIndexMaster === 0 ? 'bold' : 'normal' }} >
                        <div className='flex'>
                            {t('common.label.general')}{/* <ExclamationCircleIcon className="h-6 w-6 text-red-600 rounded-full ml-2" /> */}
                        </div>
                    </Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 1 ? 'bold' : 'normal'
                    }} >{t('common.label.asignaciones')}</Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 2 ? 'bold' : 'normal'
                    }} >
                        <div className='flex'>
                            {t('common.label.mantenimiento')}<span className='pl-[4px]'>{data?.maintenance_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.maintenance_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 3 ? 'bold' : 'normal'
                    }} ><div className='flex'>
                            {t('common.label.itv')}<span className='pl-[4px]'>{data?.inspection_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.inspection_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 4 ? 'bold' : 'normal'
                    }} ><div className='flex'>
                            {t('common.label.seguros')}<span className='pl-[4px]'>{data?.insurance_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.insurance_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 5 ? 'bold' : 'normal'
                    }} >{t('common.label.accidentes')}</Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 6 ? 'bold' : 'normal'
                    }} ><div className='flex'>
                            {t('common.label.multas')}<span className='pl-[4px]'>{data?.sanction_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.sanction_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 7 ? 'bold' : 'normal'
                    }} ><div className='flex'>
                            {t('common.label.control-km')}<span className='pl-[4px]'>{data?.mileage_status === "OK" ? (
                                <CheckIcon
                                    className={
                                        'h-5 w-5 p-1 text-white rounded-full bg-green-400'
                                    }
                                />
                            ) : data?.mileage_status === "WARNING" ? (
                                <ExclamacionYellow />
                            ) : (
                                <Exclamacion />
                            )}</span>
                        </div></Tab>
                    <Tab style={{
                        fontWeight: tabIndexMaster === 8 ? 'bold' : 'normal'
                    }} >{t('common.label.compra')}</Tab>
                     <Tab style={{
                        fontWeight: tabIndexMaster === 9 ? 'bold' : 'normal'
                    }} >{t('common.label.ultima-posicion')}</Tab>
                </TabList>

                <TabPanel>
                    <VehiculosForm onAction={handleChangeValues} isEdit={true} />
                </TabPanel>
                <TabPanel>
                    <AsignacionesTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <MantenimientoTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <ItvTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <SegurosTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <AccidentesTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <MultasTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <ControlKmTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <CompraTab item={id} onAction={handleChangeValues} />
                </TabPanel>
                <TabPanel>
                    <UltimaPosicionTab item={id} onAction={handleChangeValues} />
                </TabPanel>
            </Tabs>

        </div>
    );
};